import Link from 'next/link';
import { replacePlusSymbol } from 'pages/products/[handle]';
import React from 'react';
import { handleFreeReturn } from '@lambda/commons/helpers';
import settings from '@/settings';
import i18n from '@/settings/i18n';

const t = i18n.init();

const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

export default function DefaultSeo({
  isUSStore,
  productName,
  description,
  isSmartphone,
  productBrand,
}: {
  isUSStore: boolean;
  productName: string;
  description: string;
  isSmartphone: boolean;
  productBrand: string;
}) {
  const isApplePhone = isSmartphone && productBrand === 'Apple';

  if (!(isApplePhone && description)) {
    return (
      <div className="py-10">
        <h2 className="mb-2 text-base font-semibold !leading-5 text-gray-700 xxs:mb-3 xxs:text-lg xxs:!leading-6 xs:text-xl sm:!leading-normal md:text-2xl">
          {isUSStore
            ? `Buy Refurbished ${replacePlusSymbol(productName)} in ${
                settings.country
              }`
            : t`Buy Refurbished ${{
                name: replacePlusSymbol(productName),
              }} in ${{
                country: settings.country,
              }}`}
        </h2>
        <div className="text-sm text-gray-700">
          <p>
            {isUSStore
              ? `Looking to buy an affordable ${replacePlusSymbol(
                  productName,
                )}? Find great deals for unlocked, used ${replacePlusSymbol(
                  productName,
                )} at `
              : t`Looking to buy an affordable ${{
                  name: replacePlusSymbol(productName),
                }}? Find great deals for unlocked, used ${{
                  name: replacePlusSymbol(productName),
                }} at `}
            <Link href="/">
              <a className="font-semibold text-blue-500">Reebelo</a>
            </Link>
            .{' '}
            {t`All our second hand ${{
              name: replacePlusSymbol(productName),
            }} devices are refurbished, 100% functional and sold by trustworthy ${{
              citizen: settings.country_citizen,
            }} vendors. Enjoy extended warranty, ${{
              free_return_days: freeReturnDays,
            }} days money-back guarantee & free delivery. No matter if you are looking for a new ${{
              name: replacePlusSymbol(productName),
            }} or a refurbished ${{
              name: replacePlusSymbol(productName),
            }} - find the best prices at `}
            <Link href="/">
              <a className="font-semibold text-blue-500">Reebelo</a>
            </Link>
            !
          </p>
        </div>
      </div>
    );
  }

  return null;
}
